import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';

import ResetPinForm from './components/ResetPinForm';

export default function ResetPinModal({ handleClose }) {
  return (
    <FormModal handleClose={handleClose}>
      <ResetPinForm handleClose={handleClose} />
    </FormModal>
  );
}

ResetPinModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
